import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import {Grid} from "@mui/material";
import * as React from "react";
import styled from "@emotion/styled";
import {DrawerType} from "../../types/types";

export interface RightDrawersHeaderProps {
    openDrawer: (type: DrawerType) => void;
    drawerType: DrawerType | undefined;
}
const RightDrawersHeader = ({openDrawer, drawerType} : RightDrawersHeaderProps) => {

    return (
        <Grid direction="row" container sx={{ height: 80, paddingRight: '24px', paddingLeft: '9px' }}>
            <TopBarButtons>
                <TopBarButton
                    title="Neuigkeiten"
                    style={drawerType === DrawerType.NOTIFICATIONS ? selectedIconBackgroundStyle : {}}
                    onClick={() => openDrawer(DrawerType.NOTIFICATIONS)}
                >
                    <NotificationsNoneIcon
                        fontSize="small"
                        className="icon"
                        style={drawerType === DrawerType.NOTIFICATIONS ? selectedIconColorStyle : notSelectedIconColorStyle}
                    />
                </TopBarButton>
                <TopBarButton
                    title="Tipps & Tricks"
                    style={drawerType === DrawerType.TIPS_AND_TRICKS ? selectedIconBackgroundStyle : {}}
                    onClick={() => openDrawer(DrawerType.TIPS_AND_TRICKS)}
                >
                    <HelpOutlineOutlinedIcon
                        className="icon"
                        style={drawerType === DrawerType.TIPS_AND_TRICKS ? selectedIconColorStyle : notSelectedIconColorStyle}
                    />
                </TopBarButton>
                <TopBarButton
                    title="Einstellungen"
                    style={drawerType === DrawerType.ACCOUNT_SETTINGS ? selectedIconBackgroundStyle : {}}
                    onClick={() => openDrawer(DrawerType.ACCOUNT_SETTINGS)}
                >
                    <SettingsIcon
                        className="icon"
                        style={drawerType === DrawerType.ACCOUNT_SETTINGS ? selectedIconColorStyle : notSelectedIconColorStyle}
                    />
                </TopBarButton>
            </TopBarButtons>
            <User onClick={() => openDrawer(DrawerType.PERSONAL_SETTINGS)}>
                <div className="name">
                    <span>Aktueller Benutzer</span>
                    <span className="role">Besucher</span>
                </div>
                <div className="badge">
                    AB
                </div>
            </User>
        </Grid>
    );

};

const selectedIconColorStyle = {
    fill: '#102551'
};

const selectedIconBackgroundStyle = {
    background: '#D6D9E4'
};

const notSelectedIconColorStyle = {
    fill: 'black'
};

const TopBarButtons = styled.div`
  display: flex;
  align-items: center;
  padding-right: 5px;
  gap: 2px;

  @media (min-width: 600px) {
    gap: 12px;
    padding-right: 15px;
  }
`;

const TopBarButton = styled.div`
  cursor: pointer;
  padding: 7px 9px 4px 9px;
  border-radius: 12px;
  
  .icon {
    width: 26px;
    height: 26px;
  }
`;

const User = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-left: 1px solid #D6D9E4;
  cursor: pointer;
  
  .name {
    display: none;
    flex-direction: column;
    justify-content: end;
    align-items: end;
    font-size: 16px;
    letter-spacing: 0.003px;
    color: black;
    margin-right: 12px;
    .role {
      color: #9598A8;
      font-size: 12px;
      letter-spacing: 0.002px;
    }
    @media (min-width: 600px) {
      display: flex;
    }
  }

  .badge {
    background: #FA0;
    border-radius: 12px;
    padding: 10px;
    color: white;
    text-align: center;
    font-size: 16px;
    letter-spacing: 0.003px;
  }
`;

export default RightDrawersHeader;